export const errors = {
  MEDIA_RESOLUTION_NOT_MATCH: 'MEDIA_RESOLUTION_NOT_MATCH',
};
